import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EditorContent } from '@tiptap/react';
import EditorToolbar from '../../../components/editor/EditorToolbar';
import tiptapExtensions from '../../../components/editor/tiptapExtensions';
import useEditorWithDragDrop from '../../../components/editor/useEditorWithDragDrop';
import FileAttachment from '../../../components/FileAttachment/FileAttachment';
import { createManagerBoard } from '../../../api/managerBoardApi';

function BoardForm() {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [files, setFiles] = useState([]);
  const editor = useEditorWithDragDrop(tiptapExtensions);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim()) {
      alert('제목을 입력해주세요.');
      return;
    }

    try {
      const contentHtml = editor ? editor.getHTML() : '';

      const formData = new FormData();
      formData.append('title', title.trim());
      formData.append('content', contentHtml);
      files.forEach((f) => {
        if (f?.file) formData.append('files', f.file);
      });

      const created = await createManagerBoard(formData);
      navigate(`/manager/board/${created?.id || ''}`);
    } catch (err) {
      console.error('관리자 게시글 등록 실패:', err);
      alert('관리자 게시글 등록 실패');
    }
  };

  return (
    <div className="container-fluid view-post-write">
      <div className="row">
        <div className="col-12">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label fw-bold">제목</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">내용</label>
              <div className="border p-2 rounded">
                {editor && <EditorToolbar editor={editor} />}
                <EditorContent editor={editor} className="editor-content" />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">첨부파일</label>
              <FileAttachment files={files} setFiles={setFiles} mode="edit" />
            </div>

            <div className="d-flex justify-content-end gap-2">
              <button type="submit" className="btn btn-success">
                작성 완료
              </button>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => navigate('/manager/board')}
              >
                목록
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default BoardForm;
